import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import dayjs from 'dayjs'
import { ClientConsumer } from './context/ClientContext'
import LoadingScreen from '../components/LoadingScreen'
import Client360Tab from './details/tabs/Client360Tab'
import ClientDetailTab from './details/tabs/ClientDetailTab'
import ClientHistoryTab from './details/tabs/ClientHistoryTab'
import { CLIENT_TAB_CONFIG } from './details/constants/ClientDashboardConst'
import ClientTabs from './details/components/ClientTabs'
import { getFirstOfMonth } from '../helpers/formatDate'

const today = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
const firstOfMonth = getFirstOfMonth().format('YYYY-MM-DD HH:mm:ss')
const DefaultDates = [firstOfMonth, today]

const ShowClientApp = ({ client, editForm, successCreateForNewClient: successCreateProp }) => {
  const location = useLocation()
  const successCreateForNewClient =
    successCreateProp || location.state?.successCreateForNewClient
  const [activeTab, setActiveTab] = useState('Perfil 360')
  const [startDate, setStartDate] = useState(firstOfMonth)
  const [endDate, setEndDate] = useState(today)
  const [selectedDates, setSelectedDates] = useState([firstOfMonth, today])
  const [downloadData, setDownloadData] = useState(null)
  const [isDownloadDataFetching, setIsDownloadDataFetching] = useState(true)

  const handleDateFilter = (dates) => {
    if (!dates?.length) return
    const start = dayjs.min(dates).startOf('day')
    const end = dayjs.max(dates).endOf('day')
    const startStr = start.format('YYYY-MM-DD HH:mm:ss')
    const endStr = end.format('YYYY-MM-DD HH:mm:ss')
    setSelectedDates(dates)
    setStartDate(startStr)
    setEndDate(endStr)
  }

  const resetDates = () => {
    const start = getFirstOfMonth()
    const end = dayjs().startOf('day')
    const startStr = start.format('YYYY-MM-DD HH:mm:ss')
    const endStr = end.format('YYYY-MM-DD HH:mm:ss')
    setStartDate(startStr)
    setEndDate(endStr)
    setSelectedDates([start, end])
  }

  return (
    <>
      <ClientConsumer>
        {({ clientData, isFetching, isEditClient }) => (
          <>
            {isFetching && <LoadingScreen text="Cargando..." />}
            {!isFetching && (
              <div className="index-table">
                <div className="show-area">
                  <ClientTabs
                    tabs={CLIENT_TAB_CONFIG}
                    activeTab={activeTab}
                    onChange={setActiveTab}
                    downloadData={downloadData}
                    isDownloadDataFetching={isDownloadDataFetching}
                    clientData={clientData}
                    startDate={startDate}
                    endData={endDate}
                  />
                  <>
                    {activeTab === 'Perfil 360' && (
                      <Client360Tab
                        clientData={clientData}
                        isClientFetching={isFetching}
                        downloadData={downloadData}
                        setDownloadData={setDownloadData}
                        isDownloadDataFetching={isDownloadDataFetching}
                        setIsDownloadDataFetching={setIsDownloadDataFetching}
                        startDate={startDate}
                        endDate={endDate}
                        selectedDates={selectedDates}
                        DefaultDates={DefaultDates}
                        handleDateFilter={handleDateFilter}
                        resetDates={resetDates}
                      />
                    )}
                    {activeTab === 'Detalles' && (
                      <ClientDetailTab
                        clientData={clientData}
                        isFetching={isFetching}
                        isEditClient={isEditClient}
                        client={client}
                        editForm={editForm}
                        successCreateForNewClient={successCreateForNewClient}
                      />
                    )}
                    {activeTab === 'Historial' && <ClientHistoryTab />}
                  </>
                </div>
              </div>
            )}
          </>
        )}
      </ClientConsumer>
    </>
  )
}

export default ShowClientApp
